import { t } from '@lingui/macro';
import { AlertDialog } from 'components/dialogs/AlertDialog';
import { OverlayProps } from 'components/TaskOverlay';
import React from 'react';

interface PinConfirmationProps extends OverlayProps {
  pinned: boolean;
  onConfirmation(): void;
  isLoading: boolean;
}

export const PinConfirmation = ({
  pinned,
  onConfirmation,
  isLoading,
  isOpen,
  onClose,
}: PinConfirmationProps) => {
  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      title={pinned ? t`Unpin announcement?` : t`Pin announcement?`}
      cancelButton={{ title: t`Cancel`, onClick: onClose }}
      actionButton={{
        title: pinned ? t`Unpin` : t`Pin`,
        onClick: () => {
          onConfirmation();
        },
        isDestructive: pinned,
        isLoading,
      }}
    >
      {pinned
        ? t`It will no longer be highlighted for other users.`
        : t`The announcement will be highlighted at the top of the list.`}
    </AlertDialog>
  );
};
